import { SignupPaymentRequiredScreen } from '@/components/signup/payment-required/signup-payment-required-screen';
import { useSiteActivationContext } from '@/components/signup/site-activation/hooks/site-activation-context';
import { useUserContext } from '@/components/user-context/user-context-provider';

export const AddPaymentMethodContent = () => {
	const { user } = useUserContext();
	const { paymentDetailsView, setPaymentDetailsView } = useSiteActivationContext();

	const adminPaymentLink =
		paymentDetailsView.view === 'payment-required'
			? paymentDetailsView.adminPaymentLink
			: undefined;

	return (
		<SignupPaymentRequiredScreen
			adminPaymentLink={adminPaymentLink}
			screenName="startRovoDevTrialPaymentBlockingScreen"
			analyticsAttributes={{ userId: user?.accountId }}
			onPaymentMethodsOpened={() => setPaymentDetailsView({ view: 'payment' })}
			onCloseAndGoBack={() => setPaymentDetailsView({ view: 'site-setup' })}
		/>
	);
};
